var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')

module.exports = {

  data: function() {
  	return {
  		displayedPage: 1,
  		tasksPerPage: 10,
  		taskData: [],
  		searchString: '',
  		showUploadModal: false,
  		moreData: false,
      statusDict: {
        "0": "用户取消",
        "1": "已上传",
        "2": "已下载",
        "3": "已打印",
        "4": "打印完成",
        "-1": "打印店取消",
      }
  	}
  },

  compiled: function () {
  	loadTasks(this)
    po.vueTaskList = this
  },

  computed: {
  	displayTask: function() {
  		var searchstr = this.searchString
  		var filtereddata = this.taskData.filter(function(x){
  			return (x.name.indexOf(searchstr)!=-1) || (x.printer.indexOf(searchstr)!=-1)
  		})
  		return filtereddata
  	},
  },

  methods: {
    onUploadFile: function() {
      po.app.fileTaskParams = {
        mode: 'newfile',
        fileList: [],
        taskinfo: {},
      }
      po.app.showFileTaskModal = true
    },

    onEditTask: function($event,task) {
      po.app.showFileTaskModal = true
      po.app.fileTaskParams = {
        mode: 'edittask',
        fileList: [],
        taskinfo: task,
      }
      
    },
  	onLoadMore: function() {
  		this.displayedPage = this.displayedPage + 1
  		loadTasks(this)
  	},

  	onTaskChange: function() {
  		this.displayedPage = 1
  		loadTasks(this)
  	}
  },

}

function loadTasks(vuemodel) {
  yy_request.rest_api({
    method: 'get',
    api: 'task/',
    data: {
      page:vuemodel.displayedPage,
    },
    opSuccess: function(info) {
      var taskdata = info

      if(taskdata.length==vuemodel.tasksPerPage) {
        vuemodel.moreData = true
      } else {
        vuemodel.moreData = false
      }
      if(vuemodel.displayedPage==1) {
        vuemodel.taskData = taskdata
      } else {
        vuemodel.taskData = vuemodel.taskData.concat(taskdata)       
      }
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/tasklist.vue
// module id = 145
// module chunks = 0